import { FC } from 'react'
import { DraftData } from '../types/types'
import { getDateTimeString } from 'lib/helpers/dateHelper'

interface CodesDistributionProps {
  draftData: DraftData
}

const CodesDistribution: FC<CodesDistributionProps> = ({ draftData }) => {
  const calculateExpiryDate = (): Date => {
    const endDate = draftData.endDate || draftData.startDate
    const expiryDate = new Date(endDate)
    expiryDate.setFullYear(expiryDate.getFullYear() + 1)
    return expiryDate
  }

  const expiryDate = calculateExpiryDate()

  return (
    <div>
      <h4>Mint Links Distribution</h4>
      <p>
        <strong>Expiry Date:</strong> {getDateTimeString(expiryDate)} ({draftData.timezone})
      </p>
    </div>
  )
}

export default CodesDistribution
